import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgA1 from './assets/a1.jpg';
import ImgA2 from './assets/a2.jpg';
import ImgA3 from './assets/a3.png';
import ImgA4 from './assets/a4.jpg';
import ImgA5 from './assets/a5.jpg';
import ImgA6 from './assets/a6.jpg';
import ImgA7 from './assets/a7.jpg';
import ImgA8 from './assets/a8.jpg';
import ImgA9 from './assets/a9.jpg';
import ImgCaseyGuide from './assets/casey-guide.jpg';
import ImgSketchHome from './assets/sketch-homepage.jpg';
import ImgSketchResults from './assets/sketch-results.jpg';
import ImgUserReasearch from './assets/askdarcel-user-research.jpg';
import ImgYNABMobile from '../assets/YNABMobile.jpg';
import ImgYNABTwitch from '../assets/YNABTwitch.png';

export default class AskDarcel extends Component {

    render () {
        return (
          <div className={css.projectPage}>
            <Header
              title='AskDarcel'
              year='2017 — 2019'
              position='Program Manager & Product Designer'
            />
            <div className={css.content}>
              <img src={ImgA1} alt='AskDarcel' />
              <div className={css.text}>
                <p>In November 2017, ShelterTech begain collaborating with the SF Bar Association’s Homeless Advocacy Project to digitize the legendary HAP Manual, a 400 page tome containing all the human services available in San Francisco.</p>
                <p>Printing costs and the voluminous amount of content meant the Manual could only be revised every two years and was too expensive and cumbersome for people experiencing homelessness to utilize.</p>
                <p>AskDarcel lets anyone with access to a smartphone, tablet, or computer find the resources they need—and all the content is continuously updated via a novel approach to crowd sourcing content.</p>
              </div>
              <img src={ImgA2} alt='AskDarcel Identity' />
              <img src={ImgA3} alt='AskDarcel Brand' />
              <img src={ImgA4} alt='AskDarcel Devices' />
              <img src={ImgA5} alt='AskDarcel Icons' />
              <img src={ImgA6} alt='AskDarcel Pages' />
              <div className={css.text}>
                <p>A number of problems exist in designing for underserved communities. Technology access and digital literacy, language proficiency, diversity in devices and platforms to name a few.</p>
                <p>In our first year, our team conducted extensive user research to determine what features we should develop, what platforms we should support, and what communities we would be able to help. We partnered with other Bay Area organisations that have deeper knowledge of serving people experiencining homelessness to fill in for our relative inexperience in the industry.</p>
                <p>We also decided early on to hire people who’ve experienced homelessness to advise us on product updates and features. The Community Reps help us stay focused on the community we’re trying to help, granting us valuable insight into daily experiences that are largely voiceless in the software development industry.</p>
              </div>
              <img src={ImgUserReasearch} alt='AskDarcel User Research' />
              <div className={css.text}>
                <p>The biggest problem facing any solution for people experiencing homelessness is trust. The human services ecosystem is constantly shifting as government funding, processes, and requirements change with every new administration. The feedback we heard over and over was that digital resources rarely had correct information and there was a general distrust within the low-income community of San Francisco for tech workers and tech products.</p>
                <p>So our solution to ensuring our content is high quality and trustworthy involves addressing these two issues head on. We developed a crowd sourcing model of data validation which involves inviting volunteers from the tech community to work together with paid members of the homeless community to continuously update the content on our site. As an extra layer of oversight, our partner HAP verifies any information that’s been vetted through our process for accuracy.</p>
                <p>In 2018 we had over 200 volunteers attend these events, and they continue to be a major draw for many people who don’t know where to begin when it comes to helping the homeless and for people experiencing homelessness themselves. In solving for the biggest issue for our digital product, we’ve brought together two communities that are typically at odds and managed to save about $60,000-120,000 per year which is the typical cost of hiring staff to perform this function.</p>
              </div>
              <img src={ImgA8} alt='AskDarcel Datathons' />
              <img src={ImgA9} alt='AskDarcel Datathons' />
              <div className={css.text}>
                <p>Our users’ goal is to discover services that can help them address their needs, be that affordable housing, legal support, educational programs, and so on. </p>
                <p>Luckily for us, designing an online directory has many precedents—Google Maps, 211, Yelp, and AirBnB to name a few. Part of our design process involves integrating the features that make other directories successful but in service to communities that are overlooked and underserved. Powerful and predictive search, highly relevant results, meaningful filtering, and clear explanations how to access services is essential to the experience.</p>
              </div>
              <img src={ImgSketchHome} alt='Homepage Process' />
              <img src={ImgSketchResults} alt='Results Page Process' />
              <div className={css.text}>
                <p>To specifically address issues with digital literacy, and for users that don’t know where to begin, we’re experimenting with alternative interfaces, backed by the same trustworthy data that is the foundation of our product. </p>
                <p>Some of our experiments include chat bots, guided interfaces, goal driven to-do lists, and even printed step-by-step guides.</p>
              </div>
              <img src={ImgA7} alt='AskDarcel Mobile' />
              <img src={ImgCaseyGuide} alt='Casey Print Guide' />
              <div className={css.text}>
                <p>Want to know more about the design process for this project? <a href="https://docs.google.com/presentation/d/e/2PACX-1vQpY20_e2nBLjCI2KKY2TvxfFZw1UEDK4eoNmJYOhSL4rLSRDyk4X6QX_6vQq7HHQywwD_mcYiJrmsH/pub?start=false&loop=false&delayms=10000" target="_blank" rel="noopener noreferrer">View the case study here.</a></p>
              </div>
            </div>
            <div className={css.moreWork}>
              <header>More Projects</header>
                <ul className={css.moreWorkList}>
                  <ProjectItem
                    title='YNAB Mobile Redesign'
                    description='A spec redesign of the YNAB app'
                    exploration='Spec Redesign'
                    img={ImgYNABMobile}
                    link='YNABMobile'
                  />
                  <ProjectItem
                    title='YNAB x Twitch CoreUI'
                    description='A spec redesign of the YNAB website'
                    exploration='Spec Redesign'
                    img={ImgYNABTwitch}
                    link='YNABTwitch'
                  />
                </ul>
            </div>
          </div>
        )
     }
  }
